import { useTranslation } from 'react-i18next';
import classes from './Breadcrumb.module.css';
import { UiLink } from './UiLink';

export interface BreadcrumbItem {
  label: string;
  /** App path without language prefix; the item without one is the current page. */
  to?: string;
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useTranslation();
  if (items.length === 0) return null;

  return (
    <nav aria-label={t('ui.breadcrumb')}>
      <ol className={classes.list}>
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={`${item.label}-${item.to ?? ''}`} className={classes.item}>
              {item.to && !isLast ? (
                <UiLink to={item.to}>{item.label}</UiLink>
              ) : (
                <span aria-current={isLast ? 'page' : undefined}>{item.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
